import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import Confirm            from 'app/components/common/confirm';
import Icon               from 'app/components/common/icon';
import ModalPersonalEmail from 'app/components/common/modal-personal-email';
import Duck               from 'app/ducks/prompts';

class Prompts extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onConfirmResponse = this.onConfirmResponse.bind(this);
  }

  onConfirmResponse(didConfirm) {
    const {confirm, confirmRespond} = this.props;
    confirmRespond(confirm.key, didConfirm);
  }

  renderRequirePersonalEmail() {
    return (
      <ModalPersonalEmail />
    );
  }

  renderConfirm() {
    const {key, opts} = this.props.confirm;
    const {msg, danger} = opts;
    const confirmOpts = _.pick(opts, ['className', 'title', 'cancelBtnLabel', 'confirmBtnLabel', 'confirmBtnColor', 'doubleConfirm']);
    if (danger) {
      confirmOpts.confirmBtnLabel = confirmOpts.confirmBtnLabel || danger;
      confirmOpts.confirmBtnColor = confirmOpts.confirmBtnColor || 'danger';
    }

    return (
      <Confirm {...confirmOpts} onResponse={this.onConfirmResponse}>
        {(msg || '').split('\n').map((p, i) => <p key={i}>{p}</p>)}
      </Confirm>
    );
  }

  render() {
    const {confirm, showRpe} = this.props;
    if (showRpe) return this.renderRequirePersonalEmail();
    if (confirm) return this.renderConfirm();
    return null;
  }

}

const stateToProps = (state) => ({
  confirm: Duck.Slx.confirm(state),
  showRpe: Duck.Slx.showRpe(state),
});

const dispatchToProps = (dispatch) => ({
  confirmRespond: (key, didConfirm) => dispatch(Duck.Ax.confirmRespond(key, didConfirm)),
});

export default connect(stateToProps, dispatchToProps)(Prompts);
